// Widgets list that can be shown as an expanded node
export const NODE_WIDGET = {
  workspaceSelector: 'workspaceSelector',
  valencySelector: 'valencySelector',
};
